import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import "./style.css";
import { labelStyle } from "../../@types/productInfo";

interface Props {
  expired_date: Date | null;
  setExpiredDate: (date: Date | any) => void;
}

const CustomDatePicker: React.FC<Props> = ({ expired_date, setExpiredDate }) => {
  const handleDateChange = (date: Date | null) => {
    if (date) {
      const utcDate = new Date(Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        0, 0, 0, 0
      ));
      setExpiredDate(utcDate);
    } else {
      setExpiredDate(null);
    }
  };

  const displayDate = expired_date ? new Date(expired_date) : null;

  return (
    <div className="w-full">
      <p
        style={{
          ...(labelStyle as React.CSSProperties),
          color: "#005D6E",
        }}
      >
        Expired Date
      </p>
      <div className="w-full relative">
        <DatePicker
          selected={displayDate}
          onChange={handleDateChange}
          dateFormat="yyyy-MM-dd"
          placeholderText="Enter Expired Date"
          className="custom-datepicker w-[300px] h-12 rounded-[40px] p-4 border border-gray-300 pl-10" // Added padding to left for icon
          minDate={new Date()}
        />
      
       
      </div>
    </div>
  );
};

export default CustomDatePicker;
